import PropTypes from 'prop-types';
import React, {Component} from 'react';
import { connect } from '~/redux/connect';
import {Area, Box, H1} from "~/native-ui";
import CenterWrapper from '~/components/CenterWrapper/CenterWrapper';


class NotAuthorized extends Component {
    static propTypes = {};

    render() {
        const { trans } = this.props;

        return (
            <CenterWrapper>
                <Area text>
                    <H1>{trans('notAuthorizedPage.title')}</H1>
                    <Box>{trans('notAuthorizedPage.message')}</Box>
                </Area>
            </CenterWrapper>
        );
    }
}

const RXNotAuthorized = connect()(NotAuthorized);

export default RXNotAuthorized;